import { Alert, Button, Col, Row, Space, Tooltip } from 'antd';
import React, { ReactElement, useContext, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Panel from '../../../../../../../shared/components/card/Panel';
import { FormCheckBox, FormInputMobile, FormRadioButton, FormSelect, FormTextInput, FormInputDate } from '../../../../../../../shared/components/crmFormElement/FormInput';
import {
  AADHAR_VALIDATOR, GUTTOR_SPACE, MASKADHAAR,
  MAX_AGE_LIMIT, fieldMappings,
  MAX_CHARACTERS_LIMIT,
  MEMBER_AGE,
  NOT_ELIGIBLE_INSURER_ERR, PANCARD_REGEX_NEW, PROVIDER_SPECIFIC_FEATURES, VOTER_ID, MAX_CHARACTERS_LENGTH_LIMIT, EMAIL_CHARACTER_LIMIT,
} from '../../../../../../../shared/constants/commonConstants';
import { CORPRATE_NAME_REGEX, DECLARATION_FORM_INSURER_IDS,
  DRAFT_KEYS, EMPLOYEE_ID_REGEX, FORM_POLICY_NO_REGEX, formInputStates,
  GENDER_OPTIONS, ID_CARD_TYPE,
  OTHER_GENDER_OPTIONS, POLICY_TYPE_OPTIONS, SELECT_FOR_NEW_BORN, actions } from '../../../../../../../shared/constants/crmConstants';
import { useSmoothScroll } from '../../../../../../../shared/hooks/useSmoothScroll';
import { RootState } from '../../../../../../../store';
import { setCheckHealthIdCallback } from '../../../../../../../store/actions/idCardAction';
import {
  setGetHealthIdCard, setHealthCardType, setMemberName,
  fetchAbhVerificationMethods,
  setIsAbhaVerified,
  updateAdditionalMandatoryDocuments, setSuccessModal, setAdharVerified,
  generateVerificationOTP, getpanVerification, setAdhaarLoading, setVerificationModal,
  setSelectedOption, setIPNumberPopup, setPanNoVerified, setDlVerified, setVoterIdVerified,
  setDobModal, getVoterIdVerification, setIsNewBornCase, setSelectedMemberId,
  setClaimDetailBackupBeneficiary,
} from '../../../../../../../store/actions/newAdmissionAction';
import {
  doHealthIdValidation, panValidation, findKeyValuePair, getIsPageNameEdit, getIsPageNameNewAdmission,
  validateHealthId, voterIdValidation, getIsPageNameDetail,
  memberIdValidation,
  getPolicyNoPattern,
  getPayerConfigPropValue,
  customGTMEvent,
  pehchanNoValidation,
  getIsPageNameEditDischarge,
  getIsPageNameReconsider,
  handleUserFocus,
  prefillPolicyType,
  getSignatureOnChangeMemberName,
  getProviderFeatureFlags,
} from '../../../../service/crmUtils';
import { AdmissionContext } from '../../../AdmissionContext';
import ClaimDetailHeader from '../ClaimDetailHeader/ClaimDetailHeader';
import { CloseOutlined as Close, CloseOutlined } from '@ant-design/icons';
import { isEmpty } from 'lodash';
import { VerifyAbhaIdModel } from './VerifyAbhaIdModel';
import FormInputAndButtonGroup from '../../../../../../../shared/components/crmFormElement/FormInputAndButtonGroup/FormInputAndButtonGroup';
import FormCustomMaskedInput from '../../../../../../../shared/components/crmFormElement/FormCustomMaskedInput/FormCustomMaskedInput';
import ApplicationDetail from '../../../../../../../shared/services/applicationDetail.service';
import CONTROL_CONFIG_BASED_ON_PAYER from '../../../../../../../config/formControlConfig';
import VerifyIdentityModal from './VerifyIdentityModal';
import { ApplicationDetailModel } from '../../../../../../../store/models/applicationDetailModel';
import VerificationSuccessModal from './OTPSucessModal';
import { centeredNotification, getEmailFormat } from '../../../../../../../utils/utility';
import FormAdhaarInput from '../../../../../../../shared/components/crmFormElement/FormAdhaarInput/FormAdhaarInput';
import FormInputNumber from '../../../../../../../shared/components/crmFormElement/FormInputNumber/FormInputNumber';
import DobIdentityModal from './DobIdentityModal';
import { NHCXState } from '../../../../../../../store/models/nhcxModel';
import moment from 'moment';

const CustomerDetailCard = ({ isLoading, form, location: { pathname }, setIsCertificateNoReq }: any): ReactElement => {
  const dispatch = useDispatch();
  const { payerLookUp, payerList:
    { payer: { isInsurer, uniqueIdentifier, isGovtScheme, isOnMailPayer, isRpaPayer, name, isPOIEnabled, shortName } },
    newAdmission: {
      isBeneficiarySelected, abhaAuthModes, abhaAuthModeFail,
      abhaIdVerifiedData, isAbhaVerified, additionalMandatoryDocuments, selectedOption, adhaarVerified, panNoVerified,
      abhaIdOtpVerificationError, isManualSubmission, selectedBeneficiaryDetail, adhaarLoading, verificationModalVisible,
      searchType, beneficiaryList, isIPNumberPopUpEnabled, selectedDraft, admissionFormVal, selectedTab, newAdmissionSearchValues,
      dobLoading, dobModalVisible, dlVerified, voterIDVerified, isNewBornCase, memberId: memberIdEntered, patientConsentProceedClicked,
      consentOption, consentOptionStyle,
    },
  }: any = useSelector((state: RootState): RootState => state);
  const { isDraftBtnClicked } = useSelector((state: RootState): any => state.selectedInPatientDetail);
  const { claimDetails } = useSelector((state: RootState): any => state.admissionDetails);
  const appDetail = ApplicationDetail.instance;
  const providerSpecificFeatures = appDetail?.getProviderSpecificFeatures();
  const { insuranceCompanyName, isPehchanDisabled } = selectedBeneficiaryDetail || {};
  const [isHealthIdValid, setIsHealthIdValid] = useState(true);
  const [verifyAbha, setVerifyAbha] = useState(false);
  const [mandatoryFields, setMandatoryFields] = useState('memberId');
  const [isAbhaIdLoading, setIsAbhaIdLoading] = useState(false);
  const [isPanNumberLoading, setIsPanNumbeLoading] = useState(false);
  const [isShowAbhaModal, setIsShowAbhaModal] = useState(false);
  const [abhaId, setAbhaId] = useState('');
  const [aadharNum, setAadharNum] = useState('');
  const [referenceId, setReferenceId] = useState('');
  const [isOpenAbhaVerificationModel, setIsOpenAbhaVerificationModel] = useState(false);
  const [isGroupPolicy, setIsGroupPolicy] = useState(false);
  const [isVoterIdLoading, setIsVoterIdLoading] = useState(false);
  const [isPolicyNoReq, setIsPolicyNoReq] = useState(false);
  const [drivingLicense, setDrivingLicense] = useState('');
  const [insurerList, setInsurerList] = useState<any[]>([]);
  const payerConfig = CONTROL_CONFIG_BASED_ON_PAYER[name];
  const payerConfigValues = Object.values(payerConfig || '');
  const policyTypeField = payerConfigValues?.filter(({ type }: any): boolean => type === 'HiddenForCustomerDetailCard');
  const reqIfCorpPolicy = Boolean(payerConfigValues?.filter(({ type }: any): boolean => type === 'requiredIfCorporatePolicy')?.length);
  const inPatientField = payerConfigValues?.filter(({ label, hidden }: any): boolean => label === 'IN_PATIENT_NUMBER' && !hidden);
  const isRequiredInPatientFlag = (inPatientField?.map((ele: any): any => ele?.required));
  const [isVerifiedAbha, setIsVerifiedAbha] = useState(admissionFormVal?.customerDetail?.healthId ?
    validateHealthId(admissionFormVal?.customerDetail?.healthId) : false);
  const [isAgeDisabled, setIsAgeDisabled] = useState(false);
  // const optionalFlag =
  //   payerConfigValues?.filter(({ label, mustRequiredFlag }: any): boolean => (label === 'Insurer name') && mustRequiredFlag);
  const adharHidden = payerConfigValues.filter(({ type }: any): boolean => type === 'VIDAL').length;
  const parsedDraftData = selectedDraft?.rawDraft?.length > 0 ? JSON?.parse(selectedDraft?.rawDraft) : {};
  const mandatoryField = payerConfigValues.filter(({ isMandatory }: any): boolean => isMandatory === true).length;
  const customDisableCheck = payerConfigValues?.filter(({ type }: any): boolean => type === 'customDisableCheck');
  const customOptions: any = payerConfigValues?.filter(({ optionsType }: any): boolean => optionsType === 'customOptions');
  const isPolicyNoPatternCheckRequired =
    Boolean(payerConfigValues?.filter(({ checkPolicyNoPattern, hidden }: any): boolean =>
      checkPolicyNoPattern === true && !hidden)?.length);
  const minPropObj = payerConfigValues?.filter(({ MIN }: any): boolean => MIN);
  const isHISSearchEnabled = ApplicationDetail.instance.getIsHISSearchEnabled();
  const { selectedPatientDetail, hospitalSearchValues } = useSelector((state: RootState): any => state.hospital);
  const isNHCXEnabledProvider = ApplicationDetail.instance.getIsNHCXEnabledProvider();
  const { selectedPolicyDetail } = useSelector((state: RootState): NHCXState => state?.nhcx);
  const [inputStates, setInputStates] = useState(formInputStates.memberDetailsForm);
  const { patientDetails } = selectedPatientDetail || {};
  const consentFontSize = consentOptionStyle?.fontSize;
  const consentFontFamily = consentOptionStyle?.fontFamily;
  const { nextAllowStatus } = claimDetails || {};
  const [status] = nextAllowStatus || '';
  const isIpNoMandatory = (getProviderFeatureFlags(providerSpecificFeatures,
    PROVIDER_SPECIFIC_FEATURES.IsIpNoMandatory) && (status === actions.DISCHARGE));
  const isManipalPayer: boolean = payerConfigValues?.some((config: any): boolean => Boolean(config?.isManipalClaim)) ?? false;
  const isOrionIntegrationEnabledProvider = ApplicationDetail.instance.getIsOrionIntegrationEnabled();
  const isArtemisPayer = payerConfigValues?.some(
    (config: any): any => config?.type === 'ARTEMIS');

  useEffect((): void => {
    if (abhaAuthModes && abhaAuthModes.length > 0) {
      setIsOpenAbhaVerificationModel(true);
    }
  }, [abhaAuthModes]);

  // prefill policy type
  useEffect((): void => {
    if (!newAdmissionSearchValues?.policyType) {
      const policyOptions = customOptions?.[0]?.options || POLICY_TYPE_OPTIONS.SECTOR_TYPES;
      patientDetails?.policyType && prefillPolicyType(patientDetails?.policyType, policyOptions, form);
    }
  }, [patientDetails]);

  useEffect((): void => {
    updateMandatoryFields();
  }, [beneficiaryList]);

  const appdetails = useSelector(
    (state: RootState): ApplicationDetailModel => state.applicationDetail,
  );

  useEffect((): void => {
    if (abhaAuthModeFail) {
      setIsAbhaIdLoading(false);
    }
  }, [abhaAuthModeFail]);

  useEffect((): any => {
    if (!isAbhaVerified || !parsedDraftData?.draftAbhaVerified) {
      setIsVerifiedAbha(false);
    }
    if (process.env.REACT_APP_IS_NHCX_ENABLED === 'true' && isNHCXEnabledProvider && selectedPolicyDetail?.abhaNo) {
      setIsVerifiedAbha(true);
      dispatch(setIsAbhaVerified(true, {}));
    }
  }, [selectedTab]);

  useEffect((): void => {
    if (isDraftBtnClicked) {
      updateMandatoryFields();
    }
    if (form?.getFieldsValue(['healthId'])) {
      const formHealthId = form?.getFieldsValue(['healthId'])?.healthId;
      setIsVerifiedAbha(validateHealthId(formHealthId));
    }
    if (form?.getFieldValue(['payer'])) {
      claimDetailBackup['payer'] = form?.getFieldValue(['payer']);
    }
  }, [form?.getFieldsValue()]);

  useEffect((): void => {
    if (abhaIdVerifiedData && Object.keys(abhaIdVerifiedData).length > 0) {
      setIsOpenAbhaVerificationModel(false);
    }
  }, [abhaIdVerifiedData]);

  useEffect((): void => {
    if (abhaIdOtpVerificationError) {
      dispatch(setIsAbhaVerified(false, {}));
    }
  }, [abhaIdOtpVerificationError]);

  useEffect((): any => {
    updateMandatoryFields();
  }, [isNewBornCase, claimDetails]);

  useSmoothScroll('member-scroll');
  const admissionContext = useContext(AdmissionContext);
  const { claimDetailBackup } = admissionContext;

  const commonDetail = { isLoading, form, claimDetailBackup };
  const isNewAdmissionPage = getIsPageNameNewAdmission(pathname);
  const isDetailPage = getIsPageNameDetail(pathname);

  useEffect((): any => {
    dispatch(setClaimDetailBackupBeneficiary(claimDetailBackup));
  }, [claimDetailBackup]);

  // Field-wise validation function to check if prefilled values are valid
  const isValidFieldValue = (fieldKey: string, value: any): boolean => {
    // Return false if value is empty or undefined
    if (!value && typeof value !== 'string') {
      return false;
    }
    // Check max character limit for specific fields
    const maxLengthFields = ['corporateName', 'employeeId', 'policyNumber', 'memberId'];
    if (maxLengthFields.includes(fieldKey) && value.length > MAX_CHARACTERS_LIMIT) {
      return false;
    }
    return true;
  };

  const checkSelectedBenef = (fieldKey: string): boolean => {
    if (!isEmpty(selectedBeneficiaryDetail)) {
      const transformedKey = fieldMappings[fieldKey] || fieldKey; // Use mapped key if available
      const fieldValue = selectedBeneficiaryDetail?.[transformedKey];
      // Only return true if the field has a value AND the value is valid
      return fieldValue && isValidFieldValue(fieldKey, fieldValue);
    }
    return false;
  };

  const isFormDisabled = (key: string): boolean | undefined => {
    // If draft button is clicked, check against the parsed draft data
    if (isDraftBtnClicked) {
      if (parsedDraftData?.claimDetailBackup) {
        return !!form?.getFieldsValue([key])[key] && parsedDraftData?.claimDetailBackup?.[key];
      }
    } else {
      if (!isBeneficiarySelected) {
        // Reset specific fields for new admission
        if (getIsPageNameNewAdmission(pathname)) {
          admissionContext.claimDetailBackup.fullName = '';
          admissionContext.claimDetailBackup.memberId = '';
        }
        // Reset mobile field if HIS search is enabled
        if (isHISSearchEnabled && selectedPatientDetail) {
          admissionContext.claimDetailBackup.mobile = '';
        }
        if (!form) {
          return;
        }
      } else if (isHISSearchEnabled && selectedPatientDetail) {
        admissionContext.claimDetailBackup.mobile = '';
        if (!form) {
          return;
        }
      }
    }
    // Default: disable if field has value and exists in backup
    return !!form?.getFieldsValue([key])[key] && !!claimDetailBackup?.[key];
  };

  const onChangeFullName = ({ target: { value } }: any): void => {
    dispatch(setMemberName(value));
    getSignatureOnChangeMemberName(value, patientConsentProceedClicked, consentOption, consentFontSize, consentFontFamily);
  };

  const isRequired = (fieldName: string): boolean => {
    return (mandatoryFields.includes(fieldName)) ? true : false;
  };

  // const updateMandatoryFields = (): any => {
  //   const { memberId, corporateName, employeeId, policyNumber, policyType } =
  // form.getFieldsValue(['memberId', 'policyNumber', 'employeeId', 'corporateName', 'policyType']);
  //   if (memberId) {
  //     optionalFlag.length > 0 ?
  //     setMandatoryFields('memberId') : setMandatoryFields('memberId,insurerName');
  //   } else if (policyNumber) {
  //     setMandatoryFields('policyNumber,insurerName,insuranceCardNumber');
  //   } else if (corporateName && employeeId) {
  //     optionalFlag.length > 0 ?
  //     setMandatoryFields('corporateName,employeeId') : setMandatoryFields('corporateName,employeeId,insurerName');
  //   } else if (policyType === 'Retail') {
  //     setMandatoryFields('insuranceCardNumber,insurerName,policyNumber');
  //   } else if (policyType === 'Corporate') {
  //     setMandatoryFields('corporateNameDropdown,employeeId');
  //   } else {
  //     setMandatoryFields('memberId');
  //   }
  //   form.validateFields(['memberId', 'policyNumber', 'employeeId', 'corporateName', 'insurerName']);
  // };

  const updateMandatoryFields = (): any => {
    const { memberId, corporateName, employeeId, policyNumber, policyType, insuranceCardNumber } = form.getFieldsValue(['memberId', 'policyNumber', 'employeeId', 'corporateName', 'policyType', 'insuranceCardNumber']);
    if (memberId && (!isNewBornCase || form.getFieldsValue(['isNewBornCase']) !== 'Yes')) {
      setMandatoryFields('memberId');
    } else if (policyNumber || searchType === 'Policy No.') {
      setMandatoryFields('policyNumber');
    } else if (shortName === 'PHSI' && insuranceCardNumber && searchType === 'Employee ID') {
      setMandatoryFields('insuranceCardNumber');
    } else if ((corporateName && employeeId) || searchType === 'Employee ID') {
      setMandatoryFields('corporateName,employeeId');
    } else {
      if (isNewBornCase || form.getFieldValue(['isNewBornCase'])) {
        setMandatoryFields('policyNumber');
      } else {
        setMandatoryFields('memberId');
      }
    }
    if (isManipalPayer) { setMandatoryFields('policyNumber,memberId'); }
    // for employee id field to be mandatory -star
    if ((shortName === 'SHAI' && isRpaPayer) || shortName === 'MDSV') {
      if (policyType === 'Corporate') {
        setIsGroupPolicy(true);
      } else {
        setIsGroupPolicy(false);
      }
    }
    // Policy Number is made mandatory if Policy type is 'Corporate' for Chola
    if (reqIfCorpPolicy) {
      if (policyType === 'Corporate') {
        setIsPolicyNoReq(true);
      } else {
        setIsPolicyNoReq(false);
      }
    }
    if (isPolicyNoPatternCheckRequired && policyNumber) {
      setIsCertificateNoReq(getPolicyNoPattern(policyNumber || ''));
    }
    form.validateFields(['memberId', 'policyNumber', 'employeeId', 'corporateName']);
  };

  useEffect((): any => {
    if (!isManualSubmission) {
      updateMandatoryFields();
    }
  }, []);

  const clearHelthId = (): any => {
    setVerifyAbha(false);
    setIsHealthIdValid(true);
    form.setFields([
      {
        name: 'healthId',
        value: '',
      }]);
  };

  const verifyHealthId = (userInf: any): any => {
    let isValid = false;
    const { healthId, mobile } = form.getFieldsValue(['fullName', 'healthId', 'mobile']);
    const formattedMobile = mobile.substring(mobile.indexOf(' ') + 1).replace(/\s/g, '');
    const formattedHealthId = healthId.replace(/\s/g, '');

    if (!isEmpty(userInf)) {
      const { healthIdNumber: id, mobile: userMobile } = userInf;

      isValid = (
        userMobile === formattedMobile &&
        formattedHealthId === id
      );

      if (!isValid) {
        clearHelthId();
      }
      setIsHealthIdValid(isValid);
    } else {
      clearHelthId();
      setIsHealthIdValid(isValid);
    }
    dispatch(setGetHealthIdCard(false));
  };

  const openIDCardModal = (cardType: string): any => {
    dispatch(setHealthCardType(cardType));
    dispatch(setGetHealthIdCard(true));
    dispatch(setCheckHealthIdCallback(verifyHealthId));
  };

  const onFetchAbhVerificationMethods = (): void => {
    const healthId = form.getFieldValue('healthId');
    if (healthId?.length > 0) {
      setAbhaId(healthId);
      setIsAbhaIdLoading(true);
      dispatch(fetchAbhVerificationMethods(healthId));
      setIsShowAbhaModal(true); // for abha otp modal
    } else {
      form.setFields([
        {
          name: 'healthId',
          errors: ['ABHA ID is required to verify!'],
        },
      ]);
    }
  };

  const onVerifyAadhar = (): void => {
    if (!form?.getFieldValue('kycAdhaar')) {
      centeredNotification('Aadhar Number not found');
      return;
    }
    dispatch(setAdhaarLoading(true));
    const aadharNumber = form?.getFieldValue('kycAdhaar').replace(/\s+/g, '');
    setAadharNum(aadharNumber);
    const payload = {
      documentType: 'Adhaar',
      docNumber: aadharNumber,
      providerId: appdetails?.getProviderId(),
    };
    dispatch(generateVerificationOTP(payload, onOTPGenerateSuccess, onOTPGenerateError));
  };

  const adharClear = (): any => {
    dispatch(setAdharVerified(false));
  };

  const onOTPGenerateSuccess = (reference_id: string): void => {
    if (reference_id !== '') {
      dispatch(setVerificationModal(true));
      setReferenceId(reference_id);
    }
  };

  const onOTPGenerateError = (): void => {
    dispatch(setAdhaarLoading(false));
    centeredNotification('Aadhar Number not found');
    form.setFields([
      {
        name: 'kycAdhaar',
        value: '',
      }]);
  };

  const onOTPSuccessSubmit = (): void => {
    dispatch(setVerificationModal(false));
    dispatch(setSuccessModal(true));
    dispatch(setAdharVerified(true));
  };
  const onVerifyPan = (): void => {
    const panNumber = form?.getFieldValue('kycPan');
    if (!panNumber) {
      centeredNotification('PAN Number not found');
      return;
    }
    if (panNumber.match(PANCARD_REGEX_NEW)) {
      setIsPanNumbeLoading(true);
      const payload = {
        documentType: 'Pan',
        docNumber: panNumber,
        providerId: appdetails?.getProviderId(),
      };
      dispatch(getpanVerification(payload, onPanVerificationSucess, onPanVerificationError));
    } else {
      form.setFields([
        {
          name: 'kycPan',
          value: '',
        }]);
    }
  };

  const onPanVerificationSucess = (): void => {
    setIsPanNumbeLoading(false);
    dispatch(setSuccessModal(true));
    dispatch(setPanNoVerified(true));
  };

  const onPanVerificationError = (): void => {
    setIsPanNumbeLoading(false);
    dispatch(setPanNoVerified(false));
    form.setFields([
      {
        name: 'kycPan',
        value: '',
      }]);
    centeredNotification(`Pan verification unsucessful for new claim creation at ${appdetails.getProviderName()} Please share correct PAN No. and try again`);
  };

  const onDlVerificationSucess = (): void => {
    const drivingLicenseN0 = form?.getFieldValue('drivingLicense');
    setDrivingLicense(drivingLicenseN0);
    dispatch(setDobModal(true));

    if (!drivingLicenseN0) {
      centeredNotification('Driving License not found');
      return;
    }
  };

  const onVerifyVoterId = (): void => {
    const VoterId = form?.getFieldValue('voterId');
    if (!VoterId) {
      centeredNotification('Voter Id not found');
      return;
    }
    if (VoterId.match(VOTER_ID)) {
      setIsVoterIdLoading(true);
      const payload = {
        documentType: 'VoterId',
        docNumber: VoterId,
        providerId: appdetails?.getProviderId(),
      };
      dispatch(getVoterIdVerification(payload, onVoterIdVerificationSucess, onVoterIdVerificationError));
    } else {
      form.setFields([
        {
          name: 'voterId',
          value: '',
        }]);
    }
  };

  const onVoterIdVerificationSucess = (): void => {
    setIsVoterIdLoading(false);
    dispatch(setSuccessModal(true));
    dispatch(setVoterIdVerified(true));
  };

  const onVoterIdVerificationError = (): void => {
    dispatch(setVoterIdVerified(false));
    setIsVoterIdLoading(false);
    form.setFields([
      {
        name: 'voterId',
        value: '',
      }]);
    centeredNotification(`Voter Id verification unsucessful for new claim creation at ${appdetails.getProviderName()} Please share correct Voter Id and try again`);
  };

  const updateIdentityOptions = (selectedOptionValue: any): void => {
    dispatch(setSelectedOption(selectedOptionValue));
  };

  const changeToUpper = (event: any): void => {
    form.setFields([
      {
        name: event?.target?.id,
        value: event?.target?.value.toUpperCase(),
      },
    ]);
  };

  const onInsurerNameChange = (selectedInsurer: any): any => {
    if (selectedInsurer) {
      const { payerMasterId: insurerId } =
        findKeyValuePair(payerLookUp[uniqueIdentifier]?.insurerName, 'name', selectedInsurer) ||
        findKeyValuePair(payerLookUp[uniqueIdentifier]?.insurerName, 'value', selectedInsurer) ||
        {};
      if (getIsPageNameNewAdmission(pathname) && payerLookUp[uniqueIdentifier]?.mandatoryClassificationName?.length) {
        if (DECLARATION_FORM_INSURER_IDS.includes(insurerId) && !(additionalMandatoryDocuments || [])?.includes('declaration_form')) {
          dispatch(updateAdditionalMandatoryDocuments([...(additionalMandatoryDocuments || []), 'declaration_form']));
        } else {
          dispatch(updateAdditionalMandatoryDocuments((additionalMandatoryDocuments || [])?.filter((items: any): any => items !== 'declaration_form')));
        }
      }
    }
  };

  const closeIPNumberPopup = (): any => {
    dispatch(setIPNumberPopup(false));
  };

  const inPatientNumberRef = useRef<any>(null);
  const clickOkIPNumberPopup = (): any => {
    if (inPatientNumberRef.current) {
      inPatientNumberRef.current.focus({
        cursor: 'start',
      });
    }
    closeIPNumberPopup();
  };

  useEffect((): any => {
    if (insuranceCompanyName) {
      onInsurerNameChange(insuranceCompanyName);
    }
  }, []);

  const checkIfPOIEnabled = (): boolean => (appdetails.getIsPOIEnabledForHospital() && isPOIEnabled);

  useEffect((): any => {
    let insurers = payerLookUp[uniqueIdentifier]?.insurerName;
    if (payerLookUp[uniqueIdentifier]?.isHospSpecificInsurerPayerResponse) {
      insurers = (payerLookUp[uniqueIdentifier]?.insurerName || []).map((ele: any): any => {
        const insurerFound = (payerLookUp[uniqueIdentifier]?.providerSpecificInsurers || [])
          ?.find(({ value }: any): boolean => String(value) === String(ele?.payerMasterId));
        if (!insurerFound) {
          ele.disabled = true;
          return ele;
        }
        return ele;
      });
    }
    form.setFields([
      {
        name: 'payer',
        value: name,
      },
    ]);
    setInsurerList(insurers);
  }, [payerLookUp[uniqueIdentifier]]);

  const onHealthIdChange = (e: any): void => {
    setIsVerifiedAbha(validateHealthId(e?.target?.value));
  };

  const onEdit = (ele: any): any => (): any => {
    onEditFields(ele);
  };

  const onEditFields = (event: any): void => {
    form?.resetFields([event]);
    if (selectedOption === 'PAN NO.') {
      dispatch(setPanNoVerified(false));
    } else if (selectedOption === 'Driving License') {
      dispatch(setDlVerified(false));
    } else if (selectedOption === 'AADHAR ID') {
      dispatch(setAdharVerified(false));
    } else {
      dispatch(setVoterIdVerified(false));
    }
  };

  const requirePolicyType = (): any => {
    if (mandatoryField > 0) {
      if (newAdmissionSearchValues?.iHave === 'Employee ID') {
        return true;
      } else {
        return false;
      }
    }
  };

  const checkDisabled = (ele: any): any => {
    if (newAdmissionSearchValues?.[ele] && isBeneficiarySelected) {
      return true;
    } else {
      return false;
    }
  };
  const onChangeDOB = (ev: any): any => {
    if (ev) {
      const memberAge = moment().diff(moment(ev), 'months');
      form.setFieldsValue({ memberAge: (memberAge / 12).toFixed(2) });
      setIsAgeDisabled(true);
    } else {
      form.setFieldsValue({ memberAge: null });
      setIsAgeDisabled(false);
    }
  };

  useEffect ((): void => {
    if (form.getFieldValue(['dateOfBirth'])) {
      onChangeDOB(form.getFieldValue(['dateOfBirth']));
    }
  }, [form.getFieldValue(['dateOfBirth'])]);

  const todayDate = moment().startOf('day');

const checkDisabledNewBornCase = (): any => {
    const patientNameValue = form.getFieldValue(['fullName']);
    const isPatientNameValid = !!patientNameValue;
    if (parsedDraftData?.isNewBornCaseDraft || !getIsPageNameNewAdmission(pathname) || !isPatientNameValid) {
      return true;
    } else {
      return false;
    }
  };

  const checkNewBornCase = (): boolean => {
    if (isNewBornCase || form?.getFieldsValue(['isNewBornCase'])['isNewBornCase']?.[0] === 'Yes' || form?.getFieldsValue(['isNewBornCase'])['isNewBornCase'] === 'Yes') {
      return true;
    } else {
      return false;
    }
  };
  const onSelectNewBorn = (ev: any): any => {
    const patientName = form?.getFieldValue(['fullName']);
    const enteredMemberId = form?.getFieldValue(['memberId']);
    if (ev?.target?.checked) {
      dispatch(setIsNewBornCase(true));
      const formattedPatientName = `Baby of ${patientName || ''}`;
      form?.setFieldsValue({
        fullName: formattedPatientName,
        memberId: null,
      });
      dispatch(setMemberName(formattedPatientName));
      dispatch(setSelectedMemberId(enteredMemberId));
      if (beneficiaryList?.length > 0) {
        claimDetailBackup['memberId'] = enteredMemberId;
      }
      customGTMEvent({
        event: 'Select Newborn Checkbox',
      });
    } else {
      dispatch(setIsNewBornCase(false));
      const modifiedString = patientName?.replace('Baby of ', '');
      form?.setFieldsValue({
        fullName: modifiedString,
        memberId: memberIdEntered,
      }); dispatch(setMemberName(modifiedString));
      if (beneficiaryList?.length > 0) {
        claimDetailBackup['memberId'] = memberIdEntered;
      }

    }
    return;
  };

  const getAgeColSize = (): number => {
    if ((payerConfig?.['memberGenderSexRadio']?.hidden || !payerConfig?.['memberGenderSexRadio']) &&
      (payerConfig?.['memberGenderSex']?.hidden || !payerConfig?.['memberGenderSex']) &&
      (payerConfig?.['memberGenderSelect']?.hidden || !payerConfig?.['memberGenderSelect'])) {
      return 12;
    } else if (payerConfig?.['memberGenderSexRadio'] && !payerConfig?.['memberGenderSexRadio']?.hidden) {
      return 3;
    }
    return 4;
  };

  const getDisabledState = (
    formKey: string,
  ): boolean => {

    const isValidEmail = getEmailFormat(form?.getFieldsValue([formKey])[formKey]);
    if (formKey === 'emailId' && !isValidEmail) {
      return false; // Field should remain enabled if email is invalid or not present
    }
    return ((isNewAdmissionPage && !isDraftBtnClicked) || (parsedDraftData?.draftKey === DRAFT_KEYS.newAdmission))
    ? Boolean(isFormDisabled(formKey) && checkSelectedBenef(formKey))
    : Boolean(isFormDisabled(formKey));
  };

  return <Panel className="member-scroll" data-testid="member-detail-card">
    {
      !isNewAdmissionPage ? <ClaimDetailHeader /> : null
    }
    <Row gutter={GUTTOR_SPACE}>
      <FormTextInput detail={{
        ...commonDetail,
        key: 'fullName',
        size: 12,
        disabled: getDisabledState('fullName') || checkNewBornCase(),
        onChange: (event: any): any => onChangeFullName(event),
        isName: true,
        label: (process.env.REACT_APP_FULL_NAME_LABEL === 'true' && (shortName === 'MATPA' || shortName === 'RHITPA')) ?
          'Patient Name (as per Aadhaar)' : 'Patient Name',
        maxLength: 50,
        onFocus: (): any => handleUserFocus('fullName', setInputStates, true ),
        onBlur: (): any => handleUserFocus('fullName', setInputStates, false ),
        isShowSuggestedValue: inputStates.fullName.isShowSuggestedValue,
        leftFooterText: <div className="newBornCheckboxDiv">
          {!isDetailPage && <FormCheckBox detail={{
            ...commonDetail,
            key: 'isNewBornCase',
            checked: false,
            options: [{ value: 'Yes', onChange: onSelectNewBorn, name: SELECT_FOR_NEW_BORN }],
            hideLabel: true,
            disabled: checkDisabledNewBornCase(),
          }}
          />}
        </div>,
      }} />
      <FormInputMobile detail={{
        ...commonDetail,
        key: 'mobile',
        size: 12,
        required: true,
        onFocus: (): any => handleUserFocus('mobile', setInputStates, true ),
        onBlur: (): any => handleUserFocus('mobile', setInputStates, false ),
        isShowSuggestedValue: inputStates.mobile.isShowSuggestedValue,
        disabled: ((patientDetails?.mobileNumber || selectedPatientDetail?.mobile) &&
            hospitalSearchValues.hasOwnProperty('mobileNo')) || false,
        isExtraRuleReq: getPayerConfigPropValue(payerConfigValues, 'extraRegex', 'mobile'),
      }} />
      <FormInputDate detail={{
        ...commonDetail,
        key: 'dateOfBirth',
        size: 12,
        disabled: getDisabledState('dateOfBirth'),
        onChange: onChangeDOB,
        disabledDate: (current: any): boolean => todayDate.isBefore(moment(current), 'day'),
        onFocus: (): any => handleUserFocus('dateOfBirth', setInputStates, true ),
        onBlur: (): any => handleUserFocus('dateOfBirth', setInputStates, false ),
        isShowSuggestedValue: inputStates.dateOfBirth.isShowSuggestedValue,
      }}
      />
      <FormInputNumber detail={{
        ...commonDetail,
        key: 'memberAge',
        size: getAgeColSize(),
        disabled: getDisabledState('memberAge') || isAgeDisabled,
        suggestedValue: patientDetails?.memberAge,
        regex: MEMBER_AGE,
        maxLength: MAX_AGE_LIMIT,
        isMemberAge: true,
        onFocus: (): any => handleUserFocus('memberAge', setInputStates, true ),
        onBlur: (): any => handleUserFocus('memberAge', setInputStates, false ),
        isShowSuggestedValue: inputStates.memberAge.isShowSuggestedValue,
      }} />
      <FormSelect detail={{
        ...commonDetail,
        key: 'memberGenderSelect',
        size: payerConfig?.['memberAge']?.hidden ? 12 : 8,
        options: GENDER_OPTIONS,
        disabled: getDisabledState('memberGenderSelect'),
        onFocus: (): any => handleUserFocus('memberGenderSelect', setInputStates, true ),
        onBlur: (): any => handleUserFocus('memberGenderSelect', setInputStates, false ),
        isShowSuggestedValue: inputStates.memberGenderSelect.isShowSuggestedValue,
      }} />
      <FormTextInput detail={{
        ...commonDetail,
        key: 'memberGenderSex',
        size: payerConfig?.['memberAge']?.hidden ? 12 : 8,
        disabled: getDisabledState('memberGenderSex'),
        onFocus: (): any => handleUserFocus('memberGenderSex', setInputStates, true ),
        onBlur: (): any => handleUserFocus('memberGenderSex', setInputStates, false ),
        isShowSuggestedValue: inputStates.memberGenderSex.isShowSuggestedValue,
      }} />
      <FormRadioButton detail={{
        ...commonDetail,
        key: 'memberGenderSexRadio',
        size: payerConfig?.['memberAge']?.hidden ? 12 : 9,
        options: adharHidden !== 0 ? GENDER_OPTIONS : OTHER_GENDER_OPTIONS,
        isShowSuggestedValue: !!patientDetails,
      }} />
      <FormRadioButton detail={{
        ...commonDetail,
        key: 'retailOrCorporate',
        size: 12,
        options: POLICY_TYPE_OPTIONS.SECTOR_TYPES,
      }} />
      <FormTextInput detail={{
        ...commonDetail,
        key: 'emailId',
        size: 12,
        type: 'email',
        disabled: getDisabledState('emailId'),
        maxLength: (isOrionIntegrationEnabledProvider && isArtemisPayer) ? EMAIL_CHARACTER_LIMIT : MAX_CHARACTERS_LENGTH_LIMIT,
        onFocus: (): any => handleUserFocus('emailId', setInputStates, true ),
        onBlur: (): any => handleUserFocus('emailId', setInputStates, false ),
        isShowSuggestedValue: inputStates.emailId.isShowSuggestedValue,
      }} />
      {process.env.REACT_APP_HEALTH_ID_BUTTON_ENABLED === 'true' ?
        <div
          className={isAbhaIdLoading ? 'ant-col ant-col-md-12 health-id-wrapper c-loading' : 'ant-col ant-col-md-12 health-id-wrapper'}
        >
          <FormInputAndButtonGroup
            detail={{
              ...commonDetail,
              suffixTestId: 'form',
              placeholder: 'Enter ABHA ID',
              key: 'healthId',
              onChange: (event: any): any => onHealthIdChange(event),
              required: false,
              disabled: parsedDraftData?.draftAbhaVerified || isAbhaVerified,
              onFocus: (): any => handleUserFocus('healthId', setInputStates, true ),
              onBlur: (): any => handleUserFocus('healthId', setInputStates, false ),
              isShowSuggestedValue: inputStates.healthId.isShowSuggestedValue,
              onButtonClickHandler: onFetchAbhVerificationMethods,
              buttonLoading: isAbhaIdLoading,
              buttonDisabled: !isVerifiedAbha || parsedDraftData?.draftAbhaVerified || isAbhaVerified,
              buttonLabel: 'Verify',
              rules: [
                { required: false, message: '' },
                doHealthIdValidation,
              ],
            }}
          />
          {isHealthIdValid ? null : <div className="error-text fsize_sm health_id_padding">
            Please enter correct ABHA.</div>}
        </div>
        : null}
      <FormTextInput detail={{
        ...commonDetail,
        suffixTestId: 'form',
        key: 'memberId',
        size: 12,
        rules: shortName === 'PHSI' ? [memberIdValidation] : [],
        disabled: !checkNewBornCase() ? getDisabledState('memberId') : true,
        onChange: updateMandatoryFields,
        required: isRequired('memberId'),
        minLengthValue: getPayerConfigPropValue(minPropObj, 'MIN', 'memberId'),
        fieldLengthValue: [getPayerConfigPropValue(minPropObj, 'minimumLength', 'memberId')],
        onFocus: (): any => handleUserFocus('memberId', setInputStates, true ),
        onBlur: (): any => handleUserFocus('memberId', setInputStates, false ),
        isShowSuggestedValue: inputStates.memberId.isShowSuggestedValue,
      }} />
      {isNewAdmissionPage && checkIfPOIEnabled() &&
        <FormSelect
          detail={{
            ...commonDetail,
            key: 'identityProof',
            size: 12,
            allowClear: true,
            options: [
              { name: 'Aadhaar', value: 'Aadhaar' },
              { name: 'PAN', value: 'PAN' },
              { name: 'Driving License', value: 'Driving License', disabled: true },
              { name: 'Voter ID', value: 'Voter ID', disabled: true },
            ],
            allowOptionDisabled: true,
            onChange: updateIdentityOptions,
            disabled: adhaarVerified || panNoVerified || dlVerified || voterIDVerified,
          }}
        />
      }
      {isNewAdmissionPage ?
        <>
          {selectedOption === 'Aadhaar' &&
            <div
              className={adhaarLoading ? 'ant-col ant-col-md-12 id-wrapper c-loading' : 'ant-col ant-col-md-12 id-wrapper'}
            >
              <FormAdhaarInput
                mask={MASKADHAAR}
                regxvalidator={AADHAR_VALIDATOR}
                detail={{
                  ...commonDetail,
                  suffixTestId: 'form',
                  key: 'kycAdhaar',
                  required: true,
                  size: 20,
                  disabled: adhaarVerified,
                  buttonLabel: adhaarVerified ? 'Verified' : 'Verify',
                  onButtonClickHandler: !adhaarVerified && onVerifyAadhar,
                  onChange: adharClear,
                  buttonDisabled: adhaarVerified,
                  buttonLoading: adhaarLoading,
                  onEdit: (event: any): any => onEdit(event),
                  showVerified: adhaarVerified ? true : false,
                }}
              />
            </div>
          }
          {selectedOption === 'PAN' &&
            <div
              className={isPanNumberLoading ? 'ant-col ant-col-md-12 id-wrapper c-loading' : 'ant-col ant-col-md-12 id-wrapper'}
            >
              <FormInputAndButtonGroup
                detail={{
                  ...commonDetail,
                  suffixTestId: 'form',
                  key: 'kycPan',
                  size: 20,
                  required: true,
                  disabled: panNoVerified,
                  onChange: changeToUpper,
                  buttonLabel: panNoVerified ? 'Verified' : 'Verify',
                  onButtonClickHandler: onVerifyPan,
                  buttonLoading: isPanNumberLoading,
                  buttonDisabled: panNoVerified,
                  rules: [panValidation],
                  onEdit: (event: any): any => onEdit(event),
                  showVerified: panNoVerified ? true : false,
                  onFocus: (): any => handleUserFocus('kycPan', setInputStates, true ),
                  onBlur: (): any => handleUserFocus('kycPan', setInputStates, false ),
                  isShowSuggestedValue: inputStates.kycPan.isShowSuggestedValue,
                }}
              />
            </div>
          }
          {selectedOption === 'Driving License' &&
            <><div
              className={dobLoading ? 'ant-col ant-col-md-12 id-wrapper c-loading' : 'ant-col ant-col-md-12 id-wrapper'}
            >
              <FormInputAndButtonGroup
                detail={{
                  ...commonDetail,
                  suffixTestId: 'form',
                  key: 'drivingLicense',
                  size: 20,
                  required: true,
                  disabled: dlVerified,
                  onChange: (event: any): any => changeToUpper(event),
                  buttonLabel: dlVerified ? 'Verified' : 'Verify',
                  onButtonClickHandler: !dlVerified && onDlVerificationSucess,
                  buttonDisabled: dlVerified,
                  buttonLoading: dobLoading,
                  onEdit: (event: any): any => onEdit(event),
                  showVerified: dlVerified ? true : false,
                }} />
            </div></>
          }
          {selectedOption === 'Voter ID' &&
            <div
              className={isVoterIdLoading ? 'ant-col ant-col-md-12 id-wrapper c-loading' : 'ant-col ant-col-md-12 id-wrapper'}
            >
              <FormInputAndButtonGroup
                detail={{
                  ...commonDetail,
                  suffixTestId: 'form',
                  key: 'voterId',
                  required: true,
                  size: 20,
                  disabled: voterIDVerified,
                  onChange: (event: any): any => changeToUpper(event),
                  buttonLabel: voterIDVerified ? 'Verified' : 'Verify',
                  onButtonClickHandler: !voterIDVerified && onVerifyVoterId,
                  buttonDisabled: voterIDVerified,
                  buttonLoading: isVoterIdLoading,
                  rules: [voterIdValidation],
                  onEdit: (event: any): any => onEdit(event),
                  showVerified: voterIDVerified ? true : false,
                }}
              />
            </div>
          }
        </> :
        <>
          {claimDetailBackup['kycAdhaar'] !== null &&
            <div className={'ant-col ant-col-md-12 health-id-wrapper'}>
              <FormAdhaarInput
                mask={MASKADHAAR}
                regxvalidator={AADHAR_VALIDATOR}
                detail={{
                  ...commonDetail,
                  suffixTestId: 'form',
                  key: 'kycAdhaar',
                  required: true,
                  buttonLabel: 'Verify',
                  disabled: adhaarVerified,
                  onButtonClickHandler: onVerifyAadhar,
                  buttonLoading: adhaarLoading,
                  buttonDisabled: adhaarVerified,
                }}
              />
            </div>
          }
          {claimDetailBackup['kycPan'] !== null &&
            <div className={'ant-col ant-col-md-12 health-id-wrapper'}>
              <FormInputAndButtonGroup
                detail={{
                  ...commonDetail,
                  suffixTestId: 'form',
                  key: 'kycPan',
                  required: true,
                  disabled: panNoVerified,
                  onChange: changeToUpper,
                  buttonLabel: 'Verify',
                  onButtonClickHandler: onVerifyPan,
                  buttonLoading: isPanNumberLoading,
                  buttonDisabled: panNoVerified,
                  rules: [panValidation],
                }}
              />
            </div>
          }
        </>
      }
      {policyTypeField.length === 0 &&
        <FormSelect detail={{
          ...commonDetail,
          key: 'policyType',
          size: 12,
          allowClear: true,
          disabled: customDisableCheck?.length > 0 ? checkDisabled('policyType') || getDisabledState('policyType') :
            getDisabledState('policyType'),
          options: customOptions?.length > 0 ? customOptions?.[0]?.['options'] : POLICY_TYPE_OPTIONS.SECTOR_TYPES,
          required: requirePolicyType(),
          onChange: updateMandatoryFields,
          onFocus: (): any => handleUserFocus('policyType', setInputStates, true ),
          onBlur: (): any => handleUserFocus('policyType', setInputStates, false ),
          isShowSuggestedValue: inputStates.policyType.isShowSuggestedValue,
        }}
        />
      }
      <FormTextInput detail={{
        ...commonDetail,
        key: 'corporateName',
        size: 12,
        disabled: getDisabledState('corporateName'),
        regex: CORPRATE_NAME_REGEX,
        required: isGroupPolicy ? true : isRequired('corporateName'),
        onFocus: (): any => handleUserFocus('corporateName', setInputStates, true ),
        onBlur: (): any => handleUserFocus('corporateName', setInputStates, false ),
        isShowSuggestedValue: inputStates.corporateName.isShowSuggestedValue,
        isMaxLengthNotApplicable: true,
      }} />
      <FormTextInput detail={{
        ...commonDetail,
        key: 'employeeId',
        size: 12,
        disabled: getDisabledState('employeeId') || isGovtScheme,
        regex: EMPLOYEE_ID_REGEX,
        required: isGroupPolicy ? true : isRequired('employeeId'),
        onChange: updateMandatoryFields,
        onFocus: (): any => handleUserFocus('employeeId', setInputStates, true ),
        onBlur: (): any => handleUserFocus('employeeId', setInputStates, false ),
        isShowSuggestedValue: inputStates.employeeId.isShowSuggestedValue,
      }} />
      <FormSelect detail={{
        ...commonDetail,
        key: 'corporateNameDropdown',
        size: 12,
        options: (payerLookUp[uniqueIdentifier]?.corporate_name || []),
        showSearch: true,
        onFocus: (): any => handleUserFocus('corporateNameDropdown', setInputStates, true ),
        onBlur: (): any => handleUserFocus('corporateNameDropdown', setInputStates, false ),
        isShowSuggestedValue: inputStates.corporateNameDropdown.isShowSuggestedValue,
        required: (mandatoryField > 0 && newAdmissionSearchValues?.policyType === 'Corporate')
          ? true : isRequired('corporateNameDropdown'),
      }} />
      <FormSelect detail={{
        ...commonDetail,
        key: 'insurerName',
        size: 12,
        options: (insurerList || []),
        hidden: (isInsurer || isOnMailPayer),
        showSearch: true,
        onChange: onInsurerNameChange,
        allowOptionDisabled: true,
        disabledReason: NOT_ELIGIBLE_INSURER_ERR(),
        disabled: getDisabledState('insurerName'),
        onFocus: (): any => handleUserFocus('insurerName', setInputStates, true ),
        onBlur: (): any => handleUserFocus('insurerName', setInputStates, false ),
        isShowSuggestedValue: inputStates.insurerName.isShowSuggestedValue,
      }} />
      <FormTextInput detail={{
        ...commonDetail,
        key: 'insurerNameText',
        size: 12,
        hidden: (!isOnMailPayer),
        disabled: isFormDisabled('insurerNameText'),
        onFocus: (): any => handleUserFocus('insurerNameText', setInputStates, true ),
        onBlur: (): any => handleUserFocus('insurerNameText', setInputStates, false ),
        isShowSuggestedValue: inputStates.insurerNameText.isShowSuggestedValue,
      }} />
      <FormTextInput detail={{
        ...commonDetail,
        key: 'payer',
        size: 12,
        disabled: isFormDisabled('payer') || isRpaPayer || (selectedPolicyDetail?.payerName === form.getFieldsValue().payer),
        onFocus: (): any => handleUserFocus('payer', setInputStates, true ),
        onBlur: (): any => handleUserFocus('payer', setInputStates, false ),
        isShowSuggestedValue: inputStates.payer.isShowSuggestedValue,
      }} />
      <FormTextInput detail={{
        ...commonDetail,
        key: 'pehchanNo',
        size: 12,
        required: false,
        disabled: isPehchanDisabled,
        // isMaxLengthNotApplicable: true,
        rules: [pehchanNoValidation],
      }}
      />
      <FormTextInput detail={{
        ...commonDetail,
        key: 'policyNumber',
        size: 12,
        disabled: getDisabledState('policyNumber'),
        onFocus: (): any => handleUserFocus('policyNumber', setInputStates, true ),
        onBlur: (): any => handleUserFocus('policyNumber', setInputStates, false ),
        isShowSuggestedValue: inputStates.policyNumber.isShowSuggestedValue,
        regex: FORM_POLICY_NO_REGEX,
        required: isRequired('policyNumber') || isPolicyNoReq,
        onChange: updateMandatoryFields,
        minLengthValue: getPayerConfigPropValue(minPropObj, 'MIN', 'policyNumber'),
        fieldLengthValue: [getPayerConfigPropValue(minPropObj, 'minimumLength', 'policyNumber')],
      }} />
      <div className={'ant-col ant-col-md-12'}>
        <FormTextInput
          detail={{
            ...commonDetail,
            key: 'inPatientNumber',
            disabled: ((patientDetails?.inpatientNumber || selectedPatientDetail?.lastIPID)
              && hospitalSearchValues.hasOwnProperty('ipNumber')),
            required: isIpNoMandatory || ((shortName === 'HDFC' && process.env.REACT_APP_HDFC_FEATURES === 'true')
            ? false : ((getIsPageNameEdit(pathname) || getIsPageNameEditDischarge(pathname) || getIsPageNameReconsider(pathname)) ? true :
            isRequiredInPatientFlag[0])),
            labelClass: 'mb-0',
            onFocus: (): any => handleUserFocus('inPatientNumber', setInputStates, true ),
            onBlur: (): any => handleUserFocus('inPatientNumber', setInputStates, false ),
            isShowSuggestedValue: inputStates.inPatientNumber.isShowSuggestedValue,
            inputRef: inPatientNumberRef,
          }} />
        {
          isIPNumberPopUpEnabled && (shortName === 'MATPA' || shortName === 'RHITPA') &&
          <Space direction="vertical" className="IPNumber-popup">
            <Alert
              className="ip-number-alert-color"
              message={<>
                <div className="close-procedure-alert">
                  <CloseOutlined id="close-express-approvals" onClick={(): any => closeIPNumberPopup()} />
                </div>
                <div className="flex-element flex-row items-center justify-between gap-8">
                  Please enter IP Number for faster Discharge.
                  <Button size="small" type="primary" onClick={(): any => clickOkIPNumberPopup()} >
                    OK
                  </Button>
                </div>
              </>
              }
              closable={false}
            />
          </Space>
        }
      </div>
      {
        ApplicationDetail.instance.getisHospitalNumberEnabled() &&
        <FormTextInput // removing validations for hospital number and changing the label as well
          detail={{
            ...commonDetail,
            key: 'hospitalNumber',
            size: 12,
            required: false,
            maxLength: 25,
            onFocus: (): any => handleUserFocus('hospitalNumber', setInputStates, true ),
            onBlur: (): any => handleUserFocus('hospitalNumber', setInputStates, false ),
            isShowSuggestedValue: inputStates.hospitalNumber.isShowSuggestedValue,
          }} />}
      <FormTextInput detail={{
        ...commonDetail,
        key: 'insuranceCardNumber',
        size: 12,
        // labelClass: 'mb-0',
        required: isRequired('insuranceCardNumber'),
        onChange: updateMandatoryFields,
        onFocus: (): void => handleUserFocus('insuranceCardNumber', setInputStates, true ),
        onBlur: (): void => handleUserFocus('insuranceCardNumber', setInputStates, false ),
        isShowSuggestedValue: inputStates.insuranceCardNumber.isShowSuggestedValue,
      }} />
      {adharHidden > 0 &&
        <FormCustomMaskedInput
          mask={'9999 9999 9999'}
          regxvalidator={AADHAR_VALIDATOR}
          detail={{
            ...commonDetail,
            key: 'aadharNo',
            size: 12,
            onFocus: (): void => handleUserFocus('aadharNo', setInputStates, true ),
            onBlur: (): void => handleUserFocus('aadharNo', setInputStates, false ),
            isShowSuggestedValue: inputStates.aadharNo.isShowSuggestedValue,
          }} />
      }
      <FormInputMobile detail={{
        ...commonDetail,
        key: 'attendantContactNumber',
        size: 12,
      }} />
    </Row>
    {verifyAbha ? <React.Fragment>
      <div className={verifyAbha ? 'back-drop' : ''} />
      <div
        data-testid="Id-card-modal"
        className={`id-card-modal minimize-modal-wrapper open `}
      >
        <div className={`modal-header`}>
          <h4>Verify ABHA by entering Adhaar</h4>
          <Tooltip title="Close document window">
            <span
              onClick={clearHelthId} className="close-btn ant-modal-close-x" data-testid="minimize-icon">
              <Close />
            </span>
          </Tooltip>
        </div>
        <div className="modal-body scrollbar">
          <div className="mb-md">Do you want to verify ABHA ID ? </div>

          <Row gutter={GUTTOR_SPACE}>
            <Col md={8} offset={5}>
              <Button type={'primary'} onClick={(): void => {
                setVerifyAbha(false);
                openIDCardModal(ID_CARD_TYPE.CHECK_HEALTH_ID);
              }} data-testid="verify">
                Verify
              </Button>
            </Col>
            <Col md={10} className="text-center">
              <Button data-testid="cancel" onClick={clearHelthId}>
                Cancel
              </Button>
            </Col>
          </Row>
        </div>
      </div>
    </React.Fragment > : null}

    {(isOpenAbhaVerificationModel && isShowAbhaModal) && // for abha otp modal
      <VerifyAbhaIdModel
        data={abhaAuthModes}
        healthid={abhaId}
        setIsAbhaIdLoading={setIsAbhaIdLoading}
        closeModel={(): void => setIsOpenAbhaVerificationModel(false)}
      />
    }

    {
      <VerificationSuccessModal />
    }
    {verificationModalVisible &&
      <VerifyIdentityModal
        onOTPSuccessSubmit={onOTPSuccessSubmit}
        form={form}
        referenceId={referenceId}
        aadharNumber={aadharNum} />
    }
    {dobModalVisible &&
      <DobIdentityModal
        form={form}
        drivingLicense={drivingLicense} />
    }
  </Panel>;
};

export default withRouter(CustomerDetailCard);
